module.exports = __webpack_public_path__ + "static/assets/e6bc79c9753e70d5b184d8fc8bb4ea04.png";